import React, { cloneElement } from 'react'

import type { CSSProperties } from 'react'
import type { RendererWrapperProps } from './types'

export const RendererWrapper: React.FC<RendererWrapperProps> = ({ minWidth, maxWidth, children }) => {
  const style: CSSProperties = { ...children.props.style, minWidth, maxWidth }
  const child = cloneElement(children, { style })

  return <>{ child }</>
}
